import { normalizeOrderPushMode, parseDecimalField, parseIntegerField, type OrdatFormData } from './types.ts';

/**
 * Map the form state onto the createOrdatIntegration / updateOrdatIntegration arguments.
 *
 * `password` and `caBundle` are left out when the field is empty so an update never wipes the
 * stored secret — the backend only overwrites them when a non-empty value arrives.
 * `integrationParameters` is a graphene JSONString, so it goes over the wire JSON encoded.
 */
export const buildOrdatMutationVariables = (formData: OrdatFormData) => ({
    name: formData.name,
    baseUrl: formData.baseUrl.trim(),
    username: formData.username,
    password: formData.password || undefined,
    caBundle: formData.caBundle || undefined,
    proxy: formData.proxy,
    companyName: formData.companyName,
    businessLine: formData.businessLine,
    businessSubLine: formData.businessSubLine,
    cultureName: formData.cultureName,
    orderPushMode: normalizeOrderPushMode(formData.orderPushMode),
    defaultShipmentType: formData.defaultShipmentType,
    headerTextEnabled: formData.headerTextEnabled,
    headerTextContextId: formData.headerTextContextId,
    itemTextEnabled: formData.itemTextEnabled,
    itemTextContextId: formData.itemTextContextId,
    itemAdditionalTextContextId: parseIntegerField(formData.itemAdditionalTextContextId),
    fallbackPartNumber: formData.fallbackPartNumber,
    sellablePartsOnly: formData.sellablePartsOnly,
    attachSourceDocuments: formData.attachSourceDocuments,
    priceCheckLowerThresholdPercentage: parseDecimalField(formData.priceCheckLowerThresholdPercentage),
    priceCheckUpperThresholdPercentage: parseDecimalField(formData.priceCheckUpperThresholdPercentage),
    integrationParameters: JSON.stringify(formData.integrationParameters ?? {}),
    useOutputMapping: formData.useOutputMapping,
    orderChannels: formData.orderChannelIds,
    rfqChannels: formData.rfqChannelIds,
});
